import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#F8F9FA] py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-[#003366] mb-4">クレカ比較ナビ</h3>
            <p className="text-gray-600 text-sm">
              あなたに最適なクレジットカード選びをサポートします。
            </p>
          </div>
          <div>
            <h4 className="font-bold text-gray-700 mb-4 text-sm">カテゴリ</h4>
            <ul className="space-y-2">
              <li><Link to="/ranking" className="text-gray-600 text-sm hover:text-[#0099CC]">ランキング</Link></li>
              <li><Link to="/comparison" className="text-gray-600 text-sm hover:text-[#0099CC]">カード比較</Link></li>
              <li><Link to="/free" className="text-gray-600 text-sm hover:text-[#0099CC]">年会費無料</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-gray-700 mb-4 text-sm">人気カード</h4>
            <ul className="space-y-2">
              <li><Link to="/mitsui" className="text-gray-600 text-sm hover:text-[#0099CC]">三井住友カード（NL）</Link></li>
              <li><Link to="/ec-mall-card" className="text-gray-600 text-sm hover:text-[#0099CC]">大手ECモール系カード</Link></li>
              <li><Link to="/suruga" className="text-gray-600 text-sm hover:text-[#0099CC]">地方銀行系スピード発行カード</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-gray-700 mb-4 text-sm">関連リンク</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE" 
                  rel="nofollow"
                  target="_blank"
                  className="text-gray-600 text-sm hover:text-[#0099CC]"
                >
                  デポジット型クレジットカード公式サイト
                </a>
                <img 
                  border="0" 
                  width="1" 
                  height="1" 
                  src="https://www19.a8.net/0.gif?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE" 
                  alt=""
                  style={{ display: 'none' }}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs">
            © 2025 クレカ比較ナビ All Rights Reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 text-xs hover:text-[#0099CC]"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
